module.exports = {"id":"229712","name":"Jorge","rating":"74","photo":"./data/images/photos/1/229712.png","club":{"name":"AS Monaco","logo":"./data/images/clubs/ASMonaco.png"},"positions":["DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Jorge0.json
// module id = 2145
// module chunks = 0